import { Button, Header } from '@kanda-libs/ks-design-library';
import useHelpModal from 'components/HelpModal/useHelpModal';
import { URLS } from 'config';
import { Link } from 'react-router-dom';

export interface JobsMobileHeaderProps {
  archive: boolean;
}

const JobsMobileHeader: React.FunctionComponent<JobsMobileHeaderProps> =
  function ({ archive }) {
    const { showHelpModal } = useHelpModal();
    return archive ? (
      <Header.Base
        help={(e) => {
          if (e && typeof e.stopPropagation === 'function') {
            e.stopPropagation();
          }
          showHelpModal();
        }}
        hideNumber
      >
        <Link to={URLS.jobs}>
          <Button.Icon
            id="jobs-mobile-back"
            icon="chevron-left"
            className="-ml-4"
          />
        </Link>
      </Header.Base>
    ) : (
      <Header.Main
        help={(e) => {
          if (e && typeof e.stopPropagation === 'function') {
            e.stopPropagation();
          }
          showHelpModal();
        }}
        hideNumber
        linkComponent={Link}
      />
    );
  };

export default JobsMobileHeader;
